export enum DecisionActions {
    DECLINE = "decline application",
    APPROVE = "approve application",
    CONTRACT_SIGNED = "contract signed",
    CONTRACT_FAILED = "contract failed",
    DELETE = "Delete",
    AMEND = "Amend",
    UPDATE = "Update"
}